<p-dialog
  [(visible)]="innerVisible"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px', maxWidth: '95vw' }"
  [header]="'auth.firstTimeSetPassword.title' | translate"
  (onHide)="onDismiss()">
  <div class="flex flex-col gap-4 p-2">
    <p class="text-sm text-neutral-gray70">
      {{ 'auth.firstTimeSetPassword.subtitle' | translate }}
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-4">
      <!-- New password -->
      <div>
        <label for="fsp-password" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
          {{ 'auth.firstTimeSetPassword.passwordLabel' | translate }}
        </label>
        <input
          id="fsp-password"
          type="password"
          formControlName="password"
          autocomplete="new-password"
          class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none"
          [placeholder]="'auth.register.passwordPlaceholder' | translate" />
        @if (form.get('password')?.value) {
        <app-password-strength [password]="passwordValue" class="mt-2 block"></app-password-strength>
        } @if (form.get('password')?.touched && form.get('password')?.errors?.['required']) {
        <div class="mt-1 text-sm text-functional-error">
          {{
            'modules.scores.form.errors.required'
              | translate: { field: ('auth.firstTimeSetPassword.passwordLabel' | translate) }
          }}
        </div>
        }
      </div>

      <!-- Confirm -->
      <div>
        <label for="fsp-confirm" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
          {{ 'auth.firstTimeSetPassword.confirmLabel' | translate }}
        </label>
        <input
          id="fsp-confirm"
          type="password"
          formControlName="confirmPassword"
          autocomplete="new-password"
          class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none"
          [placeholder]="'auth.register.confirmPlaceholder' | translate" />
        @if (form.get('confirmPassword')?.touched && form.get('confirmPassword')?.errors?.['required']) {
        <div class="mt-1 text-sm text-functional-error">
          {{
            'modules.scores.form.errors.required'
              | translate: { field: ('auth.firstTimeSetPassword.confirmLabel' | translate) }
          }}
        </div>
        } @if (form.get('confirmPassword')?.touched && form.errors?.['passwordMismatch']) {
        <div class="mt-1 text-sm text-functional-error">
          {{ 'auth.register.mismatch' | translate }}
        </div>
        }
      </div>

      @if (serverError) {
      <div class="bg-functional-errorBg rounded-md border border-functional-error p-2 text-sm text-functional-error">
        {{ serverError }}
      </div>
      }

      <div class="flex justify-end">
        <button
          type="submit"
          [disabled]="!form.valid || isSubmitting"
          class="flex items-center rounded-lg bg-primary-90 p-3 text-sm font-medium text-neutral-white focus:outline-none disabled:cursor-not-allowed disabled:bg-primary-10 disabled:opacity-50">
          @if (isSubmitting) {
          <span class="spinner mr-2"></span>
          }
          {{ 'auth.firstTimeSetPassword.submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</p-dialog>
